import { graphql } from 'gatsby'
import React, { FC } from 'react'

import useSiteSettings from '../../../hooks/useSiteSettings'
import MenuEntryLink from '../header/MenuEntryLink'

export const FooterLegalMenu: FC = () => {
  const { footerLegalMenu: menuEntries } = useSiteSettings() || {}

  return (
    <nav aria-label="Footer Legal Navigation">
      <ul className="grid grid-cols-2 gap-x-10 md:gap-x-0 gap-y-1.5 [&_a]:text-xs md:grid-cols-[auto_auto_auto_auto] xl:grid-cols-4 xl:gap-x-10">
        {menuEntries &&
          menuEntries.reduce((acc: React.ReactElement[], entry) => {
            if (!entry) return acc
            const { name: entryName } = entry
            if (!entryName) return acc
            acc.push(
              <li key={entryName} className="break-words leading-none grid">
                <MenuEntryLink
                  className="no-underline"
                  link={entry.link}
                  dispensaryContactInformationRequired={entry.dispensaryContactInformationRequired}
                >
                  {entryName}
                </MenuEntryLink>
              </li>,
            )
            return acc
          }, [])}
      </ul>
    </nav>
  )
}

export const footerLegalMenu = graphql`
  fragment footerLegalMenuFragment on SanitySiteSettings {
    footerLegalMenu {
      ...MenuEntryFragment
    }
  }
`
